var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13022",
    "data-name": "Group 13022",
    transform: "translate(-80 -177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 40,
    height: 40,
    rx: 4,
    transform: "translate(80 177)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("g", {
    id: "database",
    transform: "translate(89 184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12961",
    "data-name": "Path 12961",
    d: "M11,11.143a30.649,30.649,0,0,0,6.345-.624A12.406,12.406,0,0,0,22,8.676v2.467q0,1-1.475,1.857a13.19,13.19,0,0,1-4.01,1.357,28.489,28.489,0,0,1-5.514.5,28.489,28.489,0,0,1-5.514-.5A13.19,13.19,0,0,1,1.475,13Q0,12.144,0,11.143V8.676a12.406,12.406,0,0,0,4.655,1.843A30.649,30.649,0,0,0,11,11.143Zm0,11.143a30.65,30.65,0,0,0,6.345-.624A12.406,12.406,0,0,0,22,19.819v2.467q0,1-1.475,1.857a13.19,13.19,0,0,1-4.01,1.357A28.49,28.49,0,0,1,11,26a28.49,28.49,0,0,1-5.514-.5,13.19,13.19,0,0,1-4.01-1.357Q0,23.287,0,22.286V19.819a12.406,12.406,0,0,0,4.655,1.843A30.649,30.649,0,0,0,11,22.286Zm0-5.571a30.65,30.65,0,0,0,6.345-.624A12.406,12.406,0,0,0,22,14.248v2.467q0,1-1.475,1.857a13.19,13.19,0,0,1-4.01,1.357,28.49,28.49,0,0,1-5.514.5,28.49,28.49,0,0,1-5.514-.5,13.19,13.19,0,0,1-4.01-1.357Q0,17.715,0,16.714V14.248A12.406,12.406,0,0,0,4.655,16.09,30.649,30.649,0,0,0,11,16.714ZM11,0a28.49,28.49,0,0,1,5.514.5,13.19,13.19,0,0,1,4.01,1.357Q22,2.713,22,3.714V5.571q0,1-1.475,1.857a13.19,13.19,0,0,1-4.01,1.357,28.49,28.49,0,0,1-5.514.5,28.49,28.49,0,0,1-5.514-.5,13.19,13.19,0,0,1-4.01-1.357Q0,6.573,0,5.571V3.714q0-1,1.475-1.857A13.19,13.19,0,0,1,5.486.5,28.49,28.49,0,0,1,11,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/Database.693a7ce359a9b2b255658d1fcc4926a5.svg";
export { ForwardRef as ReactComponent };